import PropTypes from 'prop-types';
import React from 'react';
import { getCloudinaryImagePathById } from '../../../utilities/images';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';

import './PaidCompanySponsorLogo.scss';

export default class PaidCompanySponsorLogo extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * name of paid company
         */
        companyName: PropTypes.string.isRequired,
        /**
         * overview link of paid company
         */
        companyUrl: PropTypes.string.isRequired,
        /**
         * image of paid companys
         */
        companyImg: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
        }),
    };

    static defaultProps = {
        companyName: '',
        companyUrl: '',
        companyImg: {
            src: '',
            alt: '',
        },
    };

    handleClick = () => {
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'paid-content-article-company-click',
        });
    };

    render() {
        const { companyName, companyImg, companyUrl } = this.props;
        return (
            <div className="component-EditorialContent-PaidCompanySponsorLogo">
                <a
                    className="anchor-wrapper"
                    href={companyUrl}
                    onClick={this.handleClick}
                >
                    <div className="img-wrapper">
                        <img
                            className="logo-img"
                            src={getCloudinaryImagePathById(
                                companyImg.src,
                                'small-medium'
                            )}
                            alt={companyImg.alt}
                        />
                    </div>
                    <div className="text">
                        Sponsored by{' '}
                        <span className="company-name">{companyName}</span>
                    </div>
                </a>
            </div>
        );
    }
}
